c
<template>
  <div class="list">
    <el-table
      row-class-name="defTableRowStyle"
      header-row-class-name="defTableHeaderStyle"
      :data="list"
      style="width: 100%"
    >
      <el-table-column label="开票时间" show-overflow-tooltip prop="account.name">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | timeFormat("yyyy-mm-dd hh:MM") }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开票金额" show-overflow-tooltip prop="contract.subject">
        <template slot-scope="scope">
          <p v-if="scope.row.amount">¥ {{ scope.row.amount | priceFormat }}</p>
          <p v-else>--</p>
        </template>
      </el-table-column>
      <el-table-column label="状态" show-overflow-tooltip prop="contract.subject">
        <template slot-scope="scope">
          <span style="color: #f77234" v-if="scope.row.state === 1">开票中</span>
          <span v-else style="color: #00c152">开票完成</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="120">
        <template slot-scope="{ row }">
          <div style="font-size: 14px; color: #0062ff" v-if="row.state === 2">
            <span @click="onDown(row)" class="pointer">下载</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div class="pagination_left"></div>
      <el-pagination
        :current-page="parm.current"
        :page-sizes="[30, 40, 50, 60]"
        :page-size.sync="parm.size"
        popper-class="paginationTopStyle"
        background
        layout="total,  prev, pager, next"
        :total="parm.total"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import getList from "@/mixins/getList";
const listParams = {};
export default {
  mixins: [getList],
  data() {
    return {
      list: [],
      listParams: {
        ...listParams,
      },
    };
  },
  mounted() {
    // this.getList();
  },
  created() {},
  computed: {},
  methods: {
    listApi(parm) {
      let data = { ...parm, ...this.listParams };
      return this.$api.getInvoiceList(data);
    },
    // 下载发票
    onDown(res) {
      if (!res.url) {
        this.$message({
          type: "error",
          message: "发票地址为空",
        });
        return;
      }
      this.$utils.downloadFile(this.$oss + res.url, res.title);
    },
  },
};
</script>

<style scoped lang="scss">
.list {
  padding: 0 16px;
  .pagination {
    display: flex;
    height: 60px;
    align-items: center;
    justify-content: space-between;
    .all {
      font-size: 14px;
      color: #666666;
      transition: all 0.3s;
      cursor: pointer;
      &:hover {
        color: #0062ff;
      }
    }
  }
}
</style>
